<template>
  <div class="experience-pkg">
    <img
      class="banner-img"
      src="/images/goods/experiencePkg/pkg-banner.png"
      alt=""
    />
    <div class="course-box">
      <div class="course-content">
        <div class="course-title">
          <img src="/images/goods/experiencePkg/title.png" alt="" />
        </div>
        <ul class="course-list">
          <li
            class="course-list-item"
            v-for="item in albumList"
            :key="item.id"
            @click="goDetail(item.id, item.dataType)"
          >
            <!-- /images/goods/experiencePkg/pkg-img.jpg -->
            <!-- 1是音频 4是视频 -->
            <div class="course-list-img">
              <img :src="item|filterImgSrc" alt="" />
            </div>
            <div class="course-list-content">
              <h3>{{ item.name }}</h3>
              <p>{{ item.description }}</p>
              <del
                >价格：¥{{
                  item.goods && item.goods.price ? item.goods.price : 0
                }}</del
              >
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="rule-box">
      <div class="rule-content">
        <p v-html="rules"></p>
      </div>
    </div>
    <div class="sticky compatible-sticky" v-if="isReady">
      <div class="button-box" v-if="!isEnd">
        <div class="share" @click="buttonHandler('share')">分享</div>
        <div
          class="price"
          :class="{ 'price-blod': isBuy }"
          @click="buttonHandler(isBuy ? 'navigateTo' : 'buy')"
          v-html="buttonBarText"
        ></div>
      </div>
      <button class="end-button-box" v-if="isEnd" @click="endHandler">
        活动已结束
      </button>
      <div class="compatible"></div>
    </div>
    <div class="compatible-empty"></div>
    <experience-pkg-share
      v-model="shareDisplay"
      @close="shareDisplay = false"
      :shareData="shareData"
      :styleData="styleData"
    ></experience-pkg-share>
  </div>
</template>

<script>
import { isEmpty, omitBy } from 'lodash'
import { mapGetters, mapMutations } from 'vuex'
import { ExperiencePkgShare } from '@/components/goods'
import { wechatPay } from '@/mixins'
import { LocalStorageUtil } from '@/utils'
import axios from 'axios';
const posterData = [{picUrl:'/images/goods/experiencePkg/advertising.png',title:'正在智伴优学APP畅学好课'}]
export default {
  name: 'ExperiencePkg',
  mixins: [wechatPay],
  components: {
    ExperiencePkgShare
  },
  data () {
    return {
      shareDisplay: false,
      activityData: {},
      activityDetail: {},
      albumList: [],
      buyCount: 0,
      isBuy: false,
      isEnd: false,
      timer: null,
      isBegin: true,
      rules: '',
      isReady: false,
      styleData:{
        shareTextBoxStyle:{
          backgroundColor: '#fb4944'
        },
        tipsStyle:{
          color: '#FAF6D9'
        }
      },
      posterData
    }
  },
  created () {
    this.loadData()
    axios.get('./data/experiencePkgRule.txt').then(response => {
      this.rules = response.data
    })
  },
  computed: {
    ...mapGetters({
      userInfo: 'auth/userInfo',
      isNative: 'externalInterface/isNative',
      uid: 'auth/uid',
      purchaseQualificationInviteCode: 'auth/purchaseQualificationInviteCode',
      downloadPath: 'externalInterface/downloadApp',
      headers: 'auth/headers',
      adultInfo: 'auth/adultInfo',
      isWeak: 'auth/isWeak',
      isPlusMember: "auth/isPlusMember",
      selfInviteCode: 'auth/selfInviteCode',
    }),
    buttonBarText () {
      if (this.isBuy) {
        return '您已抢课完成，前往学习'
      } else {
        return `¥<del>${this.activityDetail.goodsPrice ||
          0}</del>&nbsp;<span style="font-size:15px;font-weight: bold;">${this
          .activityDetail.price || 0}元抢课</span>&nbsp;<span>${this.buyCount ||
          0}人已抢</span>`
      }
    },
    getVersionControl () {
      if (this.headers.deviceType === 'website') return true
      // this.headers.deviceDetail.match(/(?<=Version:).*(?=B)/)
      // return this.headers.deviceDetail.match(/(?<=Version:).*(?=B)/) == '4.6.7'
      return this.headers.deviceDetail.indexOf('4.6.')>-1||this.headers.deviceDetail.indexOf('4.7.')>-1
    },
    getShareText() {
      let name = !!this.adultInfo && this.adultInfo.name ? this.adultInfo.name : '';
      let contextId = '';
      if (!this.isWeak||this.isPlusMember) {
        contextId = this.selfInviteCode
      } else {
        contextId = LocalStorageUtil.getContextId();
      }
      return {
        desc: "新春优学有好礼，9.9轻松购好课",
        title: `${name}邀您一起学习智伴优学独家亲子体验课`,
        imgUrl: process.env.VUE_APP_SHARE_URL + "/images/goods/experiencePkg/wechatShare.jpg",
        link: `${process.env.VUE_APP_SHARE_URL}/share.html?path=/goods/experiencePkg${contextId?'&contextId='+contextId:''}`
      }
    },
    shareData(){
      return {
        qrcodeSrc: `${process.env.VUE_APP_SHARE_URL}/index.html#/goods/experiencePkg?contextId=${this.selfInviteCode}&appId=${this.headers.appId}`,
        posterInfo: this.posterData
      }
    }
  },
  watch: {
    isReady: {
      immediate: true,
      handler: function(val) {
        if (val) {
          this.$setShareConfig(this.getShareText);
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      headers: 'auth/headers',
      setToast: 'setToastShow',
      setLoading: 'setLoadingShow'
    }),
    checkActivityStatus () {
      this.$api
        .payment_v1_activity_buy_check_id_get({
          path: {
            id: this.activityDetail.activityId
          },
          params: {
            goodsId: this.activityDetail.goodsId
          }
        })
        .then(e => {
          // 4070,"活动已结束" 4060,"活动未开始" 4080,"用户已购买" 200,"可购买"
          switch (e.code) {
            case 200:
              this.getBuyCount()
              break
            case 4060:
              this.isBegin = false
              break
            case 4070:
              this.isEnd = true
              break
            case 4080:
              this.isBuy = true
              break
            default:
              break
          }
        })
        .finally(e => {
          this.isReady = true;
        })
    },
    loadData () {
      this.$api
        .payment_v1_sys_activity_H5_id_get({
          path: {
            id: 1
          }
        })
        .then(e => {
          if (!isEmpty(e)) {
            this.activityData = e
            if (e.content && e.content.length) {
              this.activityDetail = e.content[0]
              this.albumList = omitBy(
                this.activityDetail.albums,
                item => item.charge == 0
              )
              if (this.uid) {
                this.checkActivityStatus()
              }
            }
          }
        })
        .finally(e => {
          if (!this.uid) this.isReady = true;
        })
    },
    getBuyCount () {
      this.$api.payment_v1_coupon_statistic_total_get({}).then(e => {
        if (!isEmpty(e)) {
          this.buyCount = e.total
        }
      })
    },
    buttonHandler (params) {
      if (!this.isBegin) {
        this.$store.commit('setToastShow', {
          show: true,
          content: {
            txt: '活动还未开始哦~',
            type: 'txt',
            time: 1500
          }
        })
        return
      }
      if (!this.getVersionControl) {
        this.$createDialog({
          type: 'alert',
          title: '提示',
          content: '请前往下载更新最新版本APP，更新后即可购买或分享哦~'
        }).show()
        return
      }

      if (isEmpty(this.userInfo)) {
        this.$store.commit('setToastShow', {
          show: true,
          content: {
            txt: '请登录后抢课哦~',
            type: 'txt',
            time: 500
          }
        })
        this.timer = setTimeout(() => {
          this.login()
        }, 500)
        return
      }
      let handler = {
        share: this.share,
        buy: this.buy,
        navigateTo: this.goApp
      }
      this.$api.payment_v1_coupon_statistic_post().then()
      handler[params]()
      // if (params == 'buy') this.$gio('track', 'payment_experience_clicked', 1)
    },
    login () {
      if (this.isNative) {
        this.$store.dispatch('externalInterface/navigateTo', {
          name: 'login'
        })
      } else {
        this.$router.push('/account/login-bySMS')
      }
    },
    share () {
      if (this.isNative) {
        this.$store.dispatch('externalInterface/toInvite', {
          name: 'poster',
          type: 'experiencePkg',
          posterInfo: this.posterData
          // params: {
          //   name: this.activityDetail.name
          // }
        })
      } else {
        this.shareDisplay = true
      }
    },
    buy () {
      if (this.isNative) {
        this.$store.dispatch('externalInterface/productBuy', {
          type: 'popup',
          goodsNum: this.activityDetail.goodsNum,
          name: this.activityDetail.name,
          activityId: this.activityDetail.activityId
        })
      } else {
        if (!this.purchaseQualificationInviteCode) {
          this.$router.push({
            path: '/account/bind-inviter',
            query: {
              redirect: '/goods/experiencePkg'
            }
          })
          return
        }
        this.wechatBuy()
      }
    },
    wechatBuy () {
      let params = {
        goodsNum: this.activityDetail.goodsNum,
        total: 1,
        uid: this.uid,
        openId: LocalStorageUtil.getOpenId(),
        inviteCode: this.purchaseQualificationInviteCode,
        activityId: this.activityDetail.activityId
      }
      for (let value of Object.values(params)) {
        if (!value) {
          return
        }
      }
      this.wechatPay(params, res => {
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          this.setLoading({
            show: true,
            txt: '更新数据中'
          })
          setTimeout(() => {
            this.setLoading({
              show: false
            })
            // 刷新页面
            this.checkActivityStatus()
          }, 500)
        } else {
          this.setLoading({
            show: false
          })
          this.setToast({
            show: true,
            content: {
              txt: '支付失败，请重试!',
              type: 'txt'
            }
          })
        }
      })
    },
    goApp () {
      if (this.isNative) {
        // 跳转APP-我的页面-已购课程--专题课程页面
        this.$store.dispatch('externalInterface/navigateTo', {
          name: 'boughtCourse'
        })
      } else {
        this.$store.dispatch('createDialog', {
          type: 'confirm',
          content: `学习课程需前往智伴优学APP进行收听观看哦~`,
          confirmBtn: {
            text: '立即前往',
            active: true,
            disabled: false,
            href: this.downloadPath
          },
          cancelBtn: {
            text: '暂不前往',
            active: false,
            disabled: false,
            href: 'javascript:;'
          }
        })
      }
    },
    goDetail (id, dataType) {
      if (this.isNative) {
        this.$store.dispatch('externalInterface/navigateTo', {
          name: 'album',
          params: {
            id,
            dataType
          }
        })
      } else {
        this.$router.push(
          dataType == 4 ? `/goods/video?albumId=${id}` : `/goods/detail/${id}`
        )
      }
    },
    endHandler () {
      this.$store.commit('setToastShow', {
        show: true,
        content: {
          txt: '活动已结束',
          type: 'txt'
        }
      })
    }
  },
  filters: {
    filterImgSrc(params) {
      if (!isEmpty(params)) {
        return params.dataType == 4 ? params.displayBigPhoto : params.displaySmallPhoto
      }
      return ""
    }
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  }
}
</script>

<style scoped>
.experience-pkg {
  background: #ffe8ce;
}
.experience-pkg .banner-img {
  width: 100vw;
}
.course-box {
  padding: 0 10px;
}
.course-box .course-content {
  padding: 64px 0 39px;
  border: 1px solid #fce0c1;
  background: #fce0c1;
  border-radius: 8px;
  position: relative;
}
.course-content .course-title {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -40%);
}
.course-content .course-title > img {
  width: 192.5px;
}
.course-title > img {
  width: 276.5px;
}
.course-list {
  padding: 0 10px 0 25px;
}
.course-list-item {
  display: flex;
  flex-direction: row;
  height: 110px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0px 5px 9px 0px rgba(231, 116, 60, 0.26);
}
.course-list-item + .course-list-item {
  margin-top: 35px;
}
.course-list-item .course-list-img {
  width: 95px;
  flex: 0 0 95px;
}
.course-list-item .course-list-img > img {
  width: 110px;
  height: 110px;
  border-radius: 8px;
  position: relative;
  bottom: 15px;
  right: 15px;
  box-shadow: 0px 5px 9px 0px rgba(231, 116, 60, 0.26);
  background: url('/images/goods/experiencePkg/pkg-img.jpg') no-repeat;
  background-size: 100% 100%;
}
.course-list-item .course-list-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 10px 13px 20px 15px;
  overflow: hidden;
}
.course-list-item .course-list-content > h3 {
  font-size: 14px;
  font-weight: bold;
  color: rgba(102, 88, 77, 1);
  line-height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.course-list-item .course-list-content > p {
  font-size: 10px;
  color: rgba(102, 88, 77, 1);
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-top: 5px;
}
.course-list-item .course-list-content > del {
  font-size: 12px;
  color: rgba(213, 40, 60, 1);
  line-height: 12px;
  margin-top: auto;
}
.rule-box {
  padding: 20px 10px 72px;
}
.rule-content {
  height: 317.5px;
  background: url('/images/goods/experiencePkg/rules-bg.png') no-repeat;
  background-size: 100% 100%;
  padding: 61px 18px 0;
}
.rule-content > p {
  line-height: 20px;
  color: #967737;
  font-size: 12px;
}
.button-box {
  width: 100%;
  height: 52px;
  background: url('/images/goods/experiencePkg/button-bg.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
}
.end-button-box {
  width: 100%;
  border-radius: 8px 8px 0 0;
  height: 52px;
  line-height: 52px;
  background: url('/images/goods/experiencePkg/button-end-bg.png') no-repeat;
  background-size: 100% 100%;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  text-align: center;
  color: #fef7e8;
}
.button-box .share {
  width: 146.5px;
  text-align: center;
  color: #f3533c;
  font-size: 15px;
  font-weight: bold;
}
.button-box .price {
  width: 228.5px;
  text-align: center;
  color: #fef7e8;
  font-size: 10px;
}
.button-box .price-blod {
  font-size: 15px;
  font-weight: bold;
}
.sticky {
  width: 100%;
  position: fixed;
  bottom: 0;
}
</style>
